import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Save, Mail, Shield, Settings as SettingsIcon, Share2 } from "lucide-react";

export default function IDGSettingsTab() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/idg/settings/extended").then((r) => setS(r.data)); }, []);

  const save = async () => {
    try { await api.patch("/idg/settings/extended", s); toast.success("Setări salvate"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const set = (k, v) => setS({ ...s, [k]: v });

  return (
    <div className="space-y-5" data-testid="idg-extended-settings">
      <section className="tf-surface tf-clip-card p-5 space-y-3">
        <h3 className="tf-section-title flex items-center gap-2"><SettingsIcon className="w-3.5 h-3.5" /> SEO</h3>
        <Field label="Meta title (site)" value={s.meta_title} onChange={(v) => set("meta_title", v)} testid="ext-meta-title" />
        <Field label="Meta description" value={s.meta_description} onChange={(v) => set("meta_description", v)} textarea testid="ext-meta-description" />
        <Field label="Meta keywords" value={s.meta_keywords} onChange={(v) => set("meta_keywords", v)} testid="ext-meta-keywords" />
        <Field label="Google Analytics ID (G-XXXXX)" value={s.google_analytics_id} onChange={(v) => set("google_analytics_id", v)} testid="ext-ga-id" />
      </section>

      <section className="tf-surface tf-clip-card p-5 space-y-3">
        <h3 className="tf-section-title flex items-center gap-2"><Share2 className="w-3.5 h-3.5" /> Social Media</h3>
        <div className="grid md:grid-cols-2 gap-3">
          <Field label="Facebook URL" value={s.social_facebook} onChange={(v) => set("social_facebook", v)} testid="ext-fb" />
          <Field label="Twitter / X URL" value={s.social_twitter} onChange={(v) => set("social_twitter", v)} testid="ext-tw" />
          <Field label="Instagram URL" value={s.social_instagram} onChange={(v) => set("social_instagram", v)} testid="ext-ig" />
          <Field label="Discord invite" value={s.social_discord} onChange={(v) => set("social_discord", v)} testid="ext-discord" />
          <Field label="YouTube channel" value={s.social_youtube} onChange={(v) => set("social_youtube", v)} testid="ext-yt" />
          <Field label="TikTok URL" value={s.social_tiktok} onChange={(v) => set("social_tiktok", v)} testid="ext-tt" />
        </div>
      </section>

      <section className="tf-surface tf-clip-card p-5 space-y-3">
        <h3 className="tf-section-title flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> Email SMTP</h3>
        <div className="grid md:grid-cols-2 gap-3">
          <Field label="Host SMTP" value={s.smtp_host} onChange={(v) => set("smtp_host", v)} testid="ext-smtp-host" />
          <Field label="Port" type="number" value={s.smtp_port} onChange={(v) => set("smtp_port", parseInt(v) || null)} testid="ext-smtp-port" />
          <Field label="Username" value={s.smtp_username} onChange={(v) => set("smtp_username", v)} testid="ext-smtp-user" />
          <Field label="Parolă" value={s.smtp_password} onChange={(v) => set("smtp_password", v)} type="password" testid="ext-smtp-pass" />
          <div>
            <label className="text-xs tf-section-title block mb-1">Criptare</label>
            <select className="tf-input" value={s.smtp_encryption || "none"} onChange={(e) => set("smtp_encryption", e.target.value)} data-testid="ext-smtp-encryption">
              <option value="none">Fără</option>
              <option value="tls">TLS</option>
              <option value="ssl">SSL</option>
            </select>
          </div>
          <Field label="From email" value={s.smtp_from_email} onChange={(v) => set("smtp_from_email", v)} testid="ext-smtp-from-email" />
          <Field label="From nume" value={s.smtp_from_name} onChange={(v) => set("smtp_from_name", v)} testid="ext-smtp-from-name" />
        </div>
      </section>

      <section className="tf-surface tf-clip-card p-5 space-y-3">
        <h3 className="tf-section-title flex items-center gap-2"><Shield className="w-3.5 h-3.5" /> Securitate</h3>
        <div className="grid md:grid-cols-2 gap-3">
          <Toggle label="Permite înregistrare" value={s.allow_registration} onChange={(v) => set("allow_registration", v)} testid="ext-allow-reg" />
          <Toggle label="Necesită confirmare email" value={s.require_email_confirmation} onChange={(v) => set("require_email_confirmation", v)} testid="ext-email-conf" />
          <Toggle label="Protecție CSRF" value={s.csrf_protection} onChange={(v) => set("csrf_protection", v)} testid="ext-csrf" />
          <Toggle label="Rate limiting" value={s.rate_limit_enabled} onChange={(v) => set("rate_limit_enabled", v)} testid="ext-rate-limit" />
          <Field label="Max încercări login" type="number" value={s.max_login_attempts} onChange={(v) => set("max_login_attempts", parseInt(v) || 5)} testid="ext-max-login" />
          <Field label="Blocare login (minute)" type="number" value={s.login_block_duration_min} onChange={(v) => set("login_block_duration_min", parseInt(v) || 15)} testid="ext-block-min" />
        </div>
      </section>

      <section className="tf-surface tf-clip-card p-5 space-y-3">
        <h3 className="tf-section-title">Avansate</h3>
        <div className="grid md:grid-cols-2 gap-3">
          <Toggle label="Mod mentenanță" value={s.maintenance_mode} onChange={(v) => set("maintenance_mode", v)} testid="ext-maintenance" />
          <Toggle label="Cache activ" value={s.cache_enabled} onChange={(v) => set("cache_enabled", v)} testid="ext-cache" />
          <Toggle label="Minificare assets" value={s.minify_assets} onChange={(v) => set("minify_assets", v)} testid="ext-minify" />
        </div>
        <Field label="Mesaj mentenanță" value={s.maintenance_message} onChange={(v) => set("maintenance_message", v)} textarea testid="ext-maint-msg" />
      </section>

      <button onClick={save} className="tf-btn-primary tf-clip-btn flex items-center gap-1" data-testid="idg-ext-settings-save"><Save className="w-3.5 h-3.5" /> Salvează</button>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", textarea, testid }) {
  return (
    <div>
      <label className="text-xs tf-section-title block mb-1">{label}</label>
      {textarea ? (
        <textarea className="tf-input" rows={2} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
      ) : (
        <input type={type} className="tf-input" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
      )}
    </div>
  );
}

function Toggle({ label, value, onChange, testid }) {
  return (
    <label className="flex items-center justify-between tf-surface-elev tf-clip-card-sm px-3 py-2 cursor-pointer border border-white/5">
      <span className="text-xs text-zinc-200">{label}</span>
      <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="accent-[var(--tf-primary)]" data-testid={testid} />
    </label>
  );
}
